/* eslint-disable max-len */

const Pencil: React.FC = () => (
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.5325 3.28004C13.825 2.98754 13.825 2.50004 13.5325 2.22254L11.7775 0.467544C11.5 0.175044 11.0125 0.175044 10.72 0.467544L9.34 1.84004L12.1525 4.65254M0.25 10.9375V13.75H3.0625L11.3575 5.44754L8.545 2.63504L0.25 10.9375Z" fill="#050309"/>
</svg>
);

export default Pencil;
